<template>
  <fragment>
  <noresult v-if="!entity || entity.length==0" />
    <div class="ecom-notification-box"  v-if="entity">
                                            <ul class="list-unstyled">
                                                <li class="media"  v-for="item in entity">
                                                    <span :class="getClass(item)">
                                                      <i class="feather icon-phone-incoming" v-if="item.type=='IN'"/>
                                              <i class="feather icon-phone-outgoing"  v-if="item.type=='OUT'"/>
                                              </span>
                                                    <div class="media-body">
                                                        <h5 class="action-title" v-if="item.type=='IN'">Chiamata in ingresso</h5>
                                                        <h5 class="action-title" v-if="item.type=='OUT'">Chiamata in uscita</h5>
                                                        <p class="my-3"> Chiamata da <strong>{{item.source}}</strong> ({{item.fromName}}) a <strong>{{item.destination}}</strong>  ({{item.toName}})</p>
                                                        <p><span class="badge badge-danger-inverse" v-if="item.disposition=='BUSY'">Occupato</span>
                                                        <p><span class="badge badge-danger-inverse"  v-if="item.disposition=='NO ANSWER'">Senza risposta</span>
                                                        <span class="badge badge-info-inverse"  v-if="item.disposition=='ANSWERED'">Risposta</span>
                                                        <span class="timing">{{item.start | formatFullDate}} - {{item.end | formatFullDate}}</span></p>
                                                    </div>
                                                </li>
                                               
                                            </ul>
                                        </div>
    
    
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "callList",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      entity: null,
      descriptions:[]
    };
  },
  methods: {
    getClass(item) {
      if(item.disposition =="ANSWERED")
     return "mr-3 action-icon badge badge-success-inverse";

      return "mr-3 action-icon badge badge-danger-inverse";
    },
  },

  beforeMount() {
    /*   var me = this;
            
           
*/
    let me = this;
    me.$nextTick(function () {
 
      axios.get(`call/${me.value}`).then((response) => {
        me.entity = response.data;
      });
       });
   
  },
};
</script>
